import { HttpClient } from '@angular/common/http'
import { Injectable } from '@angular/core'
import { environment } from '../../../environments/environment'
import { Observable } from 'rxjs'

@Injectable()
export class SmtpSettingsService {
  constructor(private http: HttpClient) {}

  public fetchSmtpSettings(): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_SMTP`
    return this.http.get(url, {})
  }

  public updateSmtpSettings(payload: object): Observable<any> {
    const url = `${environment.API_ENDPOINT}/admin/settings/SETTINGS_SMTP`
    return this.http.put(url, payload)
  }
}
